import React from 'react';
import { motion } from 'framer-motion';
import { Slide, SlideHeader, itemVariants } from '../Slide';
export function SlideTraction() {
  return <Slide data-id="element-310">
      <SlideHeader data-id="element-311">Traction</SlideHeader>

      <div className="flex-1 flex flex-col justify-center" data-id="element-312">
        <motion.div variants={itemVariants} className="mb-16" data-id="element-313">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif leading-[1.1] tracking-tight max-w-4xl" data-id="element-314">
            Profitable. Bootstrapped.
          </h2>
        </motion.div>

        <motion.div variants={itemVariants} className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16 pt-12 border-t border-gray-800 max-w-4xl" data-id="element-315">
          <div data-id="element-316">
            <div className="text-6xl md:text-8xl font-serif mb-4 tracking-tighter" data-id="element-317">
              35
            </div>
            <div className="text-sm text-gray-400 uppercase tracking-wider leading-relaxed" data-id="element-318">
              Customers
            </div>
          </div>
          <div data-id="element-319">
            <div className="text-6xl md:text-8xl font-serif mb-4 tracking-tighter" data-id="element-320">
              $1.2M
            </div>
            <div className="text-sm text-gray-400 uppercase tracking-wider leading-relaxed" data-id="element-321">
              Annual Recurring Revenue
            </div>
          </div>
        </motion.div>
      </div>
    </Slide>;
}